import paths from "@ingka/icons-shared/paths/cross";
import { renderPaths } from "../renderPaths.mjs";
var cross_default = () => renderPaths(paths);
export {
  cross_default as default
};
